import type { StatsigInitializeValues } from 'utils/feature-flag/instance'

import { StatsigClient } from '@statsig/js-client'
import { StatsigProvider } from '@statsig/react-bindings'
import { useState } from 'react'

type FeatureFlagProviderProps = {
  initializeValues?: StatsigInitializeValues | null
  children?: React.ReactNode
}

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  initializeValues,
  children,
}) => {
  const [statsigClient] = useState(() => {
    if (!initializeValues) {
      return null
    }

    const { user, values, clientKey } = initializeValues

    const statsigClientInstance = new StatsigClient(clientKey, user)

    statsigClientInstance.dataAdapter.setData(values)
    statsigClientInstance.initializeSync()

    return statsigClientInstance
  })

  if (statsigClient) {
    return <StatsigProvider client={statsigClient}>{children}</StatsigProvider>
  }

  return <>{children}</>
}
